export default "__VITE_ASSET__Cn29d8vz__"